import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles, lighten } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';

import { CircularProgress } from '@material-ui/core';
import { borderRadius, colors } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: borderRadius.button,
    padding: '0.73rem',
    fontWeight: 'bold',
    minWidth: 165,
    cursor: 'pointer',
    textTransform: 'none',
    '&:active': {
      opacity: 0.6,
    },
  },
  contained: {
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  containedPrimary: {
    '&:hover': {
      backgroundColor: lighten(theme.palette.primary.main, 0.3),
    },
  },
  outlined: {
    backgroundColor: colors.white,
  },
  progress: {
    width: '15px !important',
    height: '15px !important',
    color: props => (props?.variant === 'contained' ? colors.white : colors.gray),
    marginRight: theme.spacing(2),
    position: 'absolute',
  },
}));

const Button = ({ children, className, styles, variant, color, isLoading, disabled, ...rest }) => {
  const classes = useStyles({ color, variant });
  return (
    <MuiButton
      className={classnames(classes.button, className)}
      style={styles}
      color={color}
      variant={variant}
      classes={{
        contained: classes.contained,
        containedPrimary: classes.containedPrimary,
        outlined: classes.outlined,
      }}
      disabled={disabled || isLoading}
      {...rest}
    >
      {isLoading && <CircularProgress className={classes.progress} />}
      {children}
    </MuiButton>
  );
};

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  variant: PropTypes.oneOf(['contained', 'outlined']),
  color: PropTypes.oneOf(['primary', 'secondary', 'default']),
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  variant: 'contained',
  color: 'primary',
  isLoading: false,
  disabled: false,
};

export default memo(Button);
